import { render, staticRenderFns } from "./UniversityMain.vue?vue&type=template&id=57d24ef2&scoped=true&"
import script from "./UniversityMain.vue?vue&type=script&lang=js&"
export * from "./UniversityMain.vue?vue&type=script&lang=js&"
import style0 from "./UniversityMain.vue?vue&type=style&index=0&id=57d24ef2&scoped=true&lang=less&"
import style1 from "./UniversityMain.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d24ef2",
  null
  
)

export default component.exports